import React, { useEffect, useState } from 'react';

// import './css/searchBar.css';

function SearchBar(props) {
    const [searchTerm, setSearchTerm] = useState(props.searchTerm ? props.searchTerm : "");

    useEffect(() => {
        setSearchTerm(props.searchTerm);
    }, [props.searchTerm]);

    const onSearch = (e) => {
        let searchTerm = e.target.value;
        setSearchTerm(searchTerm);
        props.onSearch && props.onSearch(e, searchTerm);
        if (!searchTerm) {
            props.onClear && props.onClear(e);
        }
    };

    const onKeyPress = (e) => {
        if (e.key === 'Enter') {
            console.log('do validate');
            let searchTerm = e.target.value;
            setSearchTerm(searchTerm);
            props.onSearchClicked(e, searchTerm)
        }

    };

    const onClear = (e) => {
        setSearchTerm("");
        props.onClear && props.onClear(e);
    };

    return (
        <div className="search-bar">
            <input
                id={props.id}
                name={props.name}
                type="text"
                className={`form-control search-bar-control ${props.SearchBarClasses ? props.SearchBarClasses : ""}`}
                value={searchTerm}
                placeholder={props.placeholder ? props.placeholder : "Search Records"}
                onChange={(e) => onSearch(e)}
                onKeyDown={(e) => onKeyPress(e)} />
            {searchTerm && <span
                title="Clear"
                className="text-primary icon-clear-search me-3"
                onClick={(e) => onClear(e)}>
                <i className="fa fa-times" aria-hidden="true"></i>
            </span>}
            <span className="search-icon-btn" onClick={(e) => props.onSearchClicked && props.onSearchClicked(e, searchTerm)} title="Search">
                {/* <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M23.7871 22.7761L17.9548 16.9437C19.5193 15.145 20.4665 12.7982 20.4665 10.2333C20.4665 4.58714 15.8741 0 10.2333 0C4.58714 0 0 4.59246 0 10.2333C0 15.8741 4.59246 20.4665 10.2333 20.4665C12.7982 20.4665 15.145 19.5193 16.9437 17.9548L22.7761 23.7871C22.9144 23.9255 23.1007 24 23.2816 24C23.4625 24 23.6488 23.9308 23.7871 23.7871C24.0639 23.5104 24.0639 23.0528 23.7871 22.7761ZM1.43149 10.2333C1.43149 5.38004 5.38004 1.43681 10.2279 1.43681C15.0812 1.43681 19.0244 5.38537 19.0244 10.2333C19.0244 15.0812 15.0812 19.035 10.2279 19.035C5.38004 19.035 1.43149 15.0865 1.43149 10.2333Z" fill="#A4A4A4">
                    </path>
                </svg> */}
                <i className="fa fa-solid fa-magnifying-glass" aria-hidden="true"></i>
            </span>

        </div>
    );
}

export default SearchBar;